import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconList = props => (
  <SvgIcon {...props} viewBox="0 0 18 10">
    <path d="m0 6h2v-2h-2v2zm0 4h2v-2h-2v2zm0-8h2v-2h-2v2zm4 4h14v-2h-14v2zm0 4h14v-2h-14v2zm0-10v2h14v-2h-14z" />
  </SvgIcon>
);

export default IconList;



// WEBPACK FOOTER //
// ./src/components/icons/IconList.js